import getDataFromTokenPayload from '@utils/tokenManipulation/getDataFromTokenPayload';

export const USER_ROLE_STORAGE_KEY = 'user_role';

export const saveUserRoleToStorage = (role: string | null): string | null => {
    if (typeof window === 'undefined' || !role) return role;

    localStorage.setItem(USER_ROLE_STORAGE_KEY, role);

    return role;
};

export const removeUserRoleFromStorage = (): void => {
    if (typeof window === 'undefined') return;

    localStorage.removeItem(USER_ROLE_STORAGE_KEY);
};

const getUserRole = (): string | null => {
    const tokenRole = getDataFromTokenPayload<string>('user_role');

    if (tokenRole) {
        return saveUserRoleToStorage(tokenRole);
    }

    if (typeof window === 'undefined') return null;

    return localStorage.getItem(USER_ROLE_STORAGE_KEY);
};

export default getUserRole;
